const globalClient = null;
const globalChannel = null

export default {
    globalClient: globalClient,
    globalChannel: globalChannel
};